import React from 'react';
import { useRecoilValue } from 'recoil';
import { Label } from '@nooz-optics/nooz-components-lib';
import { UserState } from '../../../../utils/recoil/user';
import { withLocale } from '../../../../utils/hocs/withLocale';
import { UserDetailsHeader } from '../Header/userDetailsHeader';
import { UserLineOrderItem } from './UserLineOrderItem/userLineOrderItem';
import { formatContentfulComponentProps } from '../../../../utils/globals';
import { AddressCard } from '../AddressCard/addressCard';

export const ProfileOrders = withLocale(({ label, orderComponent }) => {
  const user = useRecoilValue(UserState);

  return (
    <div className='w-full pb-20'>
      <UserDetailsHeader label={label} />
      {user.orders && user?.orders?.edges?.length !== 0 ? (
        user?.orders?.edges?.map((order) => (
          <div className='pb-5'>
            <UserLineOrderItem
              order={order}
              data={formatContentfulComponentProps(orderComponent)}
            />
          </div>
        ))
      ) : (
        <AddressCard>
          <Label
            text={
              formatContentfulComponentProps(orderComponent).EmptyAccountLabel
                .text
            }
          />
        </AddressCard>
      )}
    </div>
  );
});
